<section class="unit-value-grouper">
    <gen-dynamic-form
    class="dynamic-form"
    [formName]="formId"
    [formConfig]="formConfig"
    [formData]="data"
    (formChange)="updateItemValue(data, $event)"
    [listenToDataChange]="listenToDataChange"
  ></gen-dynamic-form>
  <p class ={{classname}}>{{message}}</p>
</section>